import type { StructuredCard } from './types';
import { unescapeHtmlEntities } from '@/utils/stringUtils';

export type NutritionContent = {
  advice?: string;
  nutritionPlan?: string;
  text?: string;
  cards?: StructuredCard[];
};

export const Nutrition = ({
  content,
  renderCard,
}: {
  content: NutritionContent;
  renderCard: (card: StructuredCard, idx: number) => React.ReactNode;
}) => {
  const text = unescapeHtmlEntities(
    content.advice || content.nutritionPlan || content.text || ''
  );

  return (
    <div className='flex flex-col gap-3'>
      <div className='prose whitespace-pre-line'>{text}</div>
      {content.cards && content.cards.length > 0 && (
        <div className='flex flex-row flex-wrap gap-2 mt-1'>
          {content.cards.map((card, idx) => renderCard(card, idx))}
        </div>
      )}
    </div>
  );
};
